import { render } from "./resourceFinder.vue?vue&type=template&id=9a70cb60"
import script from "./resourceFinder.vue?vue&type=script&lang=js"
export * from "./resourceFinder.vue?vue&type=script&lang=js"

import "./resourceFinder.vue?vue&type=style&index=0&id=9a70cb60&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__